import React from 'react';
import { Link } from 'react-router-dom';
import { Home as HomeIcon, Building2, Sofa, CheckCircle2, ArrowRight } from 'lucide-react';
import SEO from '@/components/dubinko/SEO';
import { useSiteContent } from '@/hooks/useSiteContent';
import { resolveImage } from '@/lib/api';

const ICONS = { residential: HomeIcon, commercial: Building2, carpet: Sofa };

export default function ServicesPage() {
  const { content } = useSiteContent();
  const items = content.services || [];

  return (
    <main>
      <SEO
        title="Usluge — Dubinsko čišćenje stanova, poslovnih prostora, tepiha"
        description="Profesionalno dubinsko čišćenje u Nišu — stanovi i kuće, kancelarije i lokali, tepisi i tapacirani nameštaj. Detaljne usluge sa garancijom."
        path="/usluge"
      />
      <section className="section-pad aurora-bg grain">
        <div className="container-x">
          <span className="tag-pill">Sve usluge</span>
          <h1 className="font-display text-5xl md:text-6xl font-extrabold mt-4 max-w-3xl">
            Čisto. <span className="text-blue-700">Profesionalno.</span> <span className="text-emerald-600">Bez kompromisa.</span>
          </h1>
          <p className="text-slate-600 text-lg mt-5 max-w-2xl">
            Bez obzira da li imate stan od 40m², kancelariju ili tepih koji čeka revitalizaciju – pokrivamo sve.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="container-x space-y-16">
          {items.map((it, idx) => {
            const Icon = ICONS[it.key] || HomeIcon;
            return (
              <div id={it.key} key={it.key}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-10 items-center ${idx % 2 ? 'lg:[&>div:first-child]:order-2' : ''}`}>
                <div>
                  {it.image_url ? (
                    <img src={resolveImage(it.image_url)} alt={it.title} loading="lazy"
                         className="w-full aspect-[4/3] object-cover rounded-3xl shadow-xl" />
                  ) : (
                    <div className="w-full aspect-[4/3] rounded-3xl bg-slate-100 flex items-center justify-center text-slate-400">
                      Slika nije postavljena
                    </div>
                  )}
                </div>
                <div>
                  <div className="icon-wrap bg-blue-50 text-blue-700">
                    <Icon className="w-6 h-6" />
                  </div>
                  <h2 className="font-display text-3xl md:text-4xl font-bold mt-4">{it.title}</h2>
                  <p className="text-slate-600 mt-3 text-lg">{it.description}</p>
                  {it.bullets?.length > 0 && (
                    <ul className="mt-6 space-y-2.5">
                      {it.bullets.map((b) => (
                        <li key={b} className="flex items-start gap-3 text-slate-700">
                          <CheckCircle2 className="w-5 h-5 text-emerald-600 mt-0.5 shrink-0" />
                          <span>{b}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                  <Link to={`/rezervacija?service=${it.key}`}
                        className="btn-primary mt-7 inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold">
                    Zakaži ovu uslugu <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
}
